(() => {
  'use strict';
  const setup = () => {
    const gateway = document.querySelector('[data-quiz-gateway]');
    if (!gateway || gateway.dataset.initialized) return;
    const roots = {
      guided: document.querySelector('.vq-panel'),
      technical: document.querySelector('vukar-product-finder')
    };
    const panels = Object.fromEntries(Object.entries(roots).map(([key, root]) => [key, root?.closest('.shopify-section')]));
    if (!panels.guided || !panels.technical) {
      gateway.dataset.ready = 'false';
      gateway.hidden = true;
      return;
    }
    gateway.dataset.initialized = 'true';
    gateway.dataset.ready = 'true';
    const entry = gateway.querySelector('[data-gateway-entry]');
    const toolbar = gateway.querySelector('[data-gateway-selected]');
    const next = gateway.querySelector('[data-gateway-continue]');
    const inputs = [...gateway.querySelectorAll('[data-gateway-choice]')];
    const hidePanels = () => Object.values(panels).forEach(panel => {
      panel.hidden = true;
      panel.removeAttribute('data-quiz-route-active');
    });
    const showEntry = (focus = true) => {
      hidePanels();
      entry.hidden = false;
      toolbar.hidden = true;
      gateway.dataset.state = 'entry';
      next.disabled = !inputs.some(input => input.checked);
      if (focus) {
        gateway.querySelector('[data-gateway-heading]').focus({ preventScroll: true });
        gateway.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    };
    Object.entries(panels).forEach(([key, panel]) => panel.setAttribute('data-quiz-route-panel', key));
    showEntry(false);
    gateway.addEventListener('change', event => {
      if (event.target.matches('[data-gateway-choice]')) next.disabled = false;
    });
    next.addEventListener('click', () => {
      const input = inputs.find(item => item.checked);
      if (!input || !panels[input.value]) return;
      hidePanels();
      const panel = panels[input.value];
      panel.setAttribute('data-quiz-route-active', input.value);
      panel.hidden = false;
      entry.hidden = true;
      toolbar.hidden = false;
      gateway.dataset.state = 'chosen';
      gateway.querySelector('[data-gateway-selection]').textContent = input.closest('label').querySelector('.vpf__option-title').textContent;
      const heading = roots[input.value].querySelector('.vpf__title');
      if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      gateway.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
    gateway.querySelector('[data-gateway-change]').addEventListener('click', () => showEntry());
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      let url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#ttquiz-2677') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showEntry();
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
